import urlParse from 'url-parse'

export function parseUrl(url: string) {
  return urlParse(url, true)
}
